import React from 'react'
import mod from './Layout.module.css'

function Loading() {
  return (
    <div className={mod.loading}></div>
  )
}

export default Loading